import { Component, OnInit, ViewChild } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { Modal } from "ngx-modal";
import { OperatingCountryEnums } from '../../enums/countries.enums';
import { CustomerService } from '../../services/customer.service';
import { OrderService } from '../../services/order.service';
import { PaginationInstance } from 'ngx-pagination';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { RowStatus } from "../../../common/enums/row-status.enum";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReasonModel } from '../../interface/ticketingsystem/reasons.modal';
import { CacheService } from '../../../shared/services/cache.service';
import { UserInfo } from '../../../shared/interface/user-info.interface';
import { CacheKey } from "../../../shared/constants/cachekey.constants";
import { CommonService } from '../../../shared/services/common.service';
import { NotificationType } from "../../enums/notification-types.enum";
import { TranslateService } from '@ngx-translate/core';
import { Utils } from '../../../shared/Utils/utils';


@Component({
  selector: 'app-order-status-change-reason',
  templateUrl: '../../templates/template1/views/configuration/order-status-change-reason.component.html',
  styleUrls: ['../../templates/template1/themes/default/css/order-status-change-reason.component.less']
})
export class OrderStatusChangeReasonComponent implements OnInit {
  
  @ViewChild('createReasonsModal') createReasonsPopup: Modal;
  reasonsForm: FormGroup;
  isCountriesLoading = false;
  operatingCountries = [];
  modalOperatingCountry = [];
  reasons = [];
  operatingCountry: number = this._localStorageService.get('reasonsOperatingCountry') ? this._localStorageService.get('reasonsOperatingCountry') : 0;
  orderReason: string = this._localStorageService.get('reasonsSearch') ? this._localStorageService.get('reasonsSearch') : "";
  isUpdate: boolean = false;
  isSubmitted: boolean;

  userInfo: UserInfo;
  reasonId: number;
  reasonsInfo: any;
  message: string;
  rowStatus: any = RowStatus;

  sortColumn: any;
  sort: string = "DESC";

  pageNumber: number = this._localStorageService.get('reasonsPageNumber') ? this._localStorageService.get('reasonsPageNumber') : 1;
  pageSize: number = 15;
  pageCount: number = 0;
  isDesc: boolean = false;

  public paginationInstance: PaginationInstance = {
    id: 'refund-cancel-pagination',
    itemsPerPage: 10,
    currentPage: 1
  };

  constructor(private _orderservice: OrderService, private _customerservice: CustomerService, private _commonService: CommonService,
    private _localStorageService: LocalStorageService, private _formbuilder: FormBuilder, private _cacheService: CacheService, private _translatePipe: TranslateService) { }

  ngOnInit() {
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    this.buildForm();
    this.getOpCoandReasons();
  }

  buildForm() {
    this.reasonsForm = this._formbuilder.group({
      operatingCountryId: ['', Validators.required],
      reasons: ['', [Validators.required,Utils.noEmptyString]],
      reasonStatus: [],
      addAnother: []
    });
  }

  /**
 * sync two api calls for getting operating countries and cancel/refund reasons
 */
  getOpCoandReasons() {
    this.isCountriesLoading = true;
    let reqs = [];
    reqs.push(this._customerservice.getAllBusinessEntities().pipe(catchError((err: any) => {
      return of({ isError: true })
    })));
    this.setSearchValues();
    reqs.push(this._orderservice.getChangeReasons(this.sortColumn, this.operatingCountry, this.isDesc, this.pageNumber, this.pageSize, this.orderReason).pipe(catchError((err: any) => {
      return of({ isError: true })
    })));
    if (reqs.length > 0) {
      forkJoin(reqs).subscribe(response => {
        this.isCountriesLoading = false;
        const operatingCountries = response[0] ? response[0] : [];
        const reasonsData = response[1] ? response[1] : [];
        this.populateCountryValues(operatingCountries);
        this.populateReasons(reasonsData);
      }, error => {
        this.isCountriesLoading = false;
        this.operatingCountries = [];
        this.reasons = [];
        this.pageCount = 0;
      });
    }


  }

  /**
   * Get order status change reasons based on filter
   */
  getReasons() {
    this.setSearchValues();
    this._orderservice.getChangeReasons(this.sortColumn, this.operatingCountry, this.isDesc, this.pageNumber, this.pageSize, this.orderReason)
      .subscribe(response => {
        if (response) {
          this.populateReasons(response);
        } else {
          this.reasons = [];
          this.pageCount = 0;
        }
      }, err => {
        this.reasons = [];
        this.pageCount = 0;
      })
  }



  /**populate operating country values */
  populateCountryValues(operatingCountries) {
    this.modalOperatingCountry = [];
    if (operatingCountries && Array.isArray(operatingCountries)) {
      this.operatingCountries = operatingCountries;
      let countryInfo = this.operatingCountries.find((country: any) => country.id === OperatingCountryEnums.USA);
      if (countryInfo) {
        this.operatingCountries.splice(this.operatingCountries.indexOf(countryInfo), 1);
        this.operatingCountries.splice(0, 0, countryInfo);
      }
      this.populateCountryValuesForModal(operatingCountries);
    }
    else {
      this.operatingCountries = [];
    }
  }

  /**populate operating country values for modal */
  populateCountryValuesForModal(operatingCountries) {
    if (this.userInfo.hasSystemRole) {
      this.modalOperatingCountry = operatingCountries;
    }
    else {
      const allowedOperatingCountries = this.userInfo.allowedOperatingCountries ? this.userInfo.allowedOperatingCountries.split(',').map(x => +x) : [];
      if (allowedOperatingCountries.length > 0) {
        this.operatingCountries.forEach(data => {
          allowedOperatingCountries.forEach(x => {
            if (data.id == x) { this.modalOperatingCountry.push(data); }
          })
        })
      }
      else { this.modalOperatingCountry = []; }
    }
  }

  /**populate reasons data and bind it to grid */
  populateReasons(data) {
    if (data && !data.isError) {
      const reasonContent = data["content"] ? data["content"]:[];
      this.operatingCountries.forEach(item => {
        reasonContent.forEach(data => {
          if (item.id == data.operatingCountryId) {
            data.countryname = item.name;
            data.status = RowStatus[data.rowStatusId];
            if (this.userInfo.hasSystemRole) {
              data.hasAccess = true;
            }
            else {
              const allowedOperatingCountries = this.userInfo.allowedOperatingCountries ? this.userInfo.allowedOperatingCountries.split(',').map(x => +x) : [];
              if (allowedOperatingCountries.length > 0) {
                allowedOperatingCountries.forEach(x => {
                  if (data.operatingCountryId == x) {
                    data.hasAccess = true;
                  }
                })
              }
              else {
                data.hasAccess = false;
              }
            }
          }
        })
      })
      this.reasons = reasonContent ? reasonContent : [];
      this.pageCount = data["totalCount"]? data["totalCount"]:0;
    }
    else {
      this.reasons = [];
      this.pageCount = 0;
    }
  }


  setSearchValues() {
    if (this.operatingCountry) {
      this._localStorageService.set('reasonsOperatingCountry', this.operatingCountry);
    }
    if (this.orderReason) {
      this._localStorageService.set('reasonsSearch', this.orderReason);
    }
    this._localStorageService.set('reasonsPageNumber', this.pageNumber);
  }

  onSearch() {
    window.document.getElementById("search-button").classList.add('button-active');
    setTimeout(() => {
      window.document.getElementById("search-button").classList.remove('button-active');
    }, 1000);
    this.pageNumber = 1;
    this.getReasons();
  }


  clearFields() {
    this.setFocusToDropDown();
    this.operatingCountry = 0;
    this.orderReason = ""
    this.pageNumber = 1;
    this.isDesc = false;
    this._localStorageService.remove('reasonsOperatingCountry');
    this._localStorageService.remove('reasonsSearch');
    this._localStorageService.remove('reasonsPageNumber');
    this.getReasons();
  }

  setFocusToDropDown() {
    setTimeout(function () {
      const autoFocusElement = document.getElementById("autofocus-element");
      if (autoFocusElement) {
        autoFocusElement.focus();
      }
    }, 200);
  }


  /**
    * sort table by respective column
    * @param sortColumn 
    */

  sortTableByColumn(sortColumn: string) {
    this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
    this.sort = this.isDesc ? "DESC" : "ASC";
    this.sortColumn = sortColumn;
    this.getReasons();

  }

  /**
    * On Page change 
    * @param pageNumber 
    */
  pageChange(pageNumber: number) {
    if (!isNaN(pageNumber)) {
      this.pageNumber = pageNumber;
      this.getReasons();
    }
  }


  openCreateReasonModal() {
    this.resetReasonsForms();
    if (this.isUpdate) {
      this.isUpdate = false;
    }
    this.createReasonsPopup.open();
    setTimeout(function () {
      const autoFocusElement = document.getElementById("autofocus-modal-element");
      if (autoFocusElement) {
        autoFocusElement.focus();
      }
    }, 200);
  }


  closePopUp() {
    this.createReasonsPopup.close();
  }

  onSubmit(isValid) {
    this.isSubmitted = true;
    if (isValid) {
      this.isSubmitted = false;
      let reasonData = new ReasonModel();
      reasonData.operatingCountryId = parseInt(this.reasonsForm.get('operatingCountryId').value);
      reasonData.reasonNote = this.reasonsForm.get('reasons').value ? this.reasonsForm.get('reasons').value.trim():'';
      reasonData.rowStatusId = this.reasonsForm.get('reasonStatus').value ? RowStatus.Active : RowStatus.Inactive;
      let country = this.operatingCountries.find(item => item.id === +this.reasonsForm.get('operatingCountryId').value);
      country ? reasonData.operatingCountryCode = country.value : null;
      if (!this.isUpdate) {
        reasonData.createdBy = this.userInfo.userId;
      }
      else {
        reasonData.id = this.reasonId;
        reasonData.updatedBy = this.userInfo.userId;
      }
      this.isUpdate ? this.updateReason(reasonData) : this.createReasons(reasonData);
    }
  }

  resetReasonsForms() {
    this.reasonsForm.get('operatingCountryId').setValue('');
    this.reasonsForm.get('operatingCountryId').markAsUntouched();
    this.reasonsForm.get('reasons').setValue('');
    this.reasonsForm.get('reasons').markAsUntouched();
    this.reasonsForm.get('reasonStatus').setValue('');
    this.reasonsForm.get('addAnother').setValue('');
  }

  editReasoneForm(value: any) {
    this.isUpdate = true;
    this.reasonId = value;
    this.resetReasonsForms();
    this.getReasonById(value);
    this.createReasonsPopup.open();
    setTimeout(function () {
      const element = document.getElementById("reasonsInput-focus");
      if (element) {
        element.focus();
      }
    }, 200);
  }

  /**
   * 
   * @param id 
   * get reasons details based on id 
   */
  getReasonById(id: any) {
    this._orderservice.getReason(id).subscribe((response: any) => {
      if (response) {
        this.reasonsInfo = response;
        this.reasonsForm.patchValue({
          operatingCountryId: this.reasonsInfo.operatingCountryId,
          reasons: this.reasonsInfo.reasonNote,
          reasonStatus: (this.reasonsInfo.rowStatusId == RowStatus.Active) ? true : false
        })
      }
    });
  }


  /**
   * 
   * @param Reason 
   *Update the existing reasons with Reason payload
   */
  updateReason(Reason: ReasonModel) {
    this._orderservice.createAndUpdateReasons(Reason).subscribe(response => {
      if (response && response.success && response.validations.length === 0) {
        const message: any = (this._translatePipe.get('config-system.Cancel/Refund reason updated successfully') as any);
        this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
        this.isDesc = false;
        this.getReasons();
        this.createReasonsPopup.close();
      }
      else if (response && !response.success && response.validations.length > 0) {
        this.message = response.validations[0].message;
        this._commonService.createNotification("", this.message, NotificationType.ERROR);
      }
      else {
        const message: any = this._translatePipe.get('config-system.Cancel/Refund updation failed');
        this._commonService.createNotification("", message.value, NotificationType.ERROR);
      }
    }, error => {
      const message: any = this._translatePipe.get('config-system.Cancel/Refund updation failed');
      this._commonService.createNotification("", message.value, NotificationType.ERROR);
    })
  }


  /**
   * 
   * @param Reason 
   * Add new  reasons  with Reason payload
   */
  createReasons(Reason: ReasonModel) {
    this._orderservice.createAndUpdateReasons(Reason).subscribe((response: any) => {
      if (response && response.validations.length === 0 && response.success) {
        const message: any = this._translatePipe.get('config-system.Cancel/Refund reason created successfully');
        this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
        this.isSubmitted = false;
        this.isDesc = false;
        this.getReasons();
        if (this.reasonsForm.get('addAnother').value) {
          this.reasonsForm.get('operatingCountryId').setValue('');
          this.reasonsForm.get('operatingCountryId').markAsUntouched();
          this.reasonsForm.get('reasons').setValue('');
          this.reasonsForm.get('reasons').markAsUntouched();
          this.reasonsForm.get('reasonStatus').setValue('');
        }
        else {
          this.resetReasonsForms();
          this.createReasonsPopup.close();
        }

      }
      else if (response && !response.success && response.validations.length > 0) {
        this.message = response.validations[0].message;
        this._commonService.createNotification("", this.message, NotificationType.ERROR);
        var backdropelement = document.getElementsByClassName('modal-backdrop')[0];
        backdropelement.classList.remove('in');
        setTimeout(() => {
          backdropelement.classList.add('in');
        }, 3000);
      }
      else {
        const message: any = this._translatePipe.get('config-system.Cancel/Refund creation failed');
        this._commonService.createNotification("", message.value, NotificationType.ERROR);
      }
    },
      error => {
        const message: any = this._translatePipe.get('config-system.Cancel/Refund creation failed');
        this._commonService.createNotification("", message.value, NotificationType.ERROR);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/configuration/order-status-change-reason.component.ts